import React from 'react';

export default function Info() {
	return (
		<svg
			className="svg info"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			width="20"
			height="20"
		>
			<path
				d="M17.07 17.07C15.18 18.96 12.67 20 9.997 20s-5.183-1.04-7.073-2.93c-3.9-3.9-3.9-10.243 0-14.142C4.814 1.04 7.326 0 9.997 0s5.183 1.04 7.073 2.93A9.93 9.93 0 0120 10a9.93 9.93 0 01-2.93 7.071zm-.884-13.26c-1.653-1.65-3.851-2.56-6.189-2.56s-4.535.9-6.188 2.563a8.76 8.76 0 000 12.375c1.653 1.652 3.85 2.563 6.188 2.563s4.536-.9 6.188-2.562A8.69 8.69 0 0018.75 10a8.69 8.69 0 00-2.564-6.187zM11.3 15.625H8.77A.63.63 0 018.138 15a.63.63 0 01.633-.625h.633v-5H8.77a.63.63 0 01-.633-.625.63.63 0 01.633-.625h1.265a.63.63 0 01.633.625v5.624h.633a.63.63 0 01.632.625.63.63 0 01-.632.625zm-1.265-8.75a1.26 1.26 0 01-1.265-1.25 1.26 1.26 0 011.265-1.25 1.26 1.26 0 011.265 1.25 1.26 1.26 0 01-1.265 1.25z"
				fill="#fff"
			/>
		</svg>
	);
}
